module.exports = __webpack_public_path__ + "static/media/icons-yc-ruler-unusable.11d7eb6d.svg";